<div class="tw-m-3 tw-flex tw-items-center tw-justify-between">
  <div>
    <ate-button-control class="tw-w-fit tw-min-w-0 tw-p-3" (click)="goBack()" color="secondary">
      <ate-icon name="chevron-left-v2"></ate-icon>
      <span class="tw-hidden md:tw-block">Back</span>
    </ate-button-control>
  </div>
</div>
<div
  class="tw-overflow-hidden tw-border-b tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-slate-200 tw-bg-white md:tw-mx-3 md:tw-mx-[10px] md:tw-mx-[10px] md:tw-mx-[10px] md:tw-rounded-[5px] md:tw-border-l md:tw-border-r">
  @if (!isConnected) {
    <ate-marketplace-page-container>
      <ate-ui-utility-message imageSrc="assets/images/info-icon.png" title="Connect Gmail">
        <p>Link your Gmail account to view your inbox here.</p>
        <ate-button-control class="tw-flex tw-gap-2" [routerLink]="['/su', listingUuid, 'integrations', 'email']" color="secondary">
          <ate-icon class="tw-h-5 tw-w-5" name="settings-v3"></ate-icon>
          <span class="tw-hidden md:tw-block">Connect Gmail</span>
        </ate-button-control>
      </ate-ui-utility-message>
    </ate-marketplace-page-container>
  } @else {
    <form class="marketplace" [formGroup]="form">
      <div class="form-row title tw-mx-0 tw-rounded-lg tw-rounded-b-none tw-border-0 tw-bg-blue-50 !tw-p-5" *ngIf="templateOptions?.length > 1">
        <div class="header">
          <div class="tw-mb-3 tw-items-center tw-justify-between tw-gap-2 md:tw-flex">
            <div class="tw-flex tw-items-center tw-gap-2">
              <ate-icon class="tw-size-5 tw-text-slate-700" name="quote-template-v3"></ate-icon>
              <label for="templateUuid" class="!tw-mb-0 tw-block tw-font-bold tw-text-slate-800">Create email from template</label>
            </div>
            <a
              [routerLink]="['/su', listing?.uuid || 'me', 'manage', language, 'templates', 'email']"
              target="_blank"
              class="tw-flex tw-items-center tw-gap-1 tw-bg-gradient-to-r tw-from-brand-gradientfrom tw-to-brand-gradientto tw-bg-clip-text tw-font-bold tw-text-transparent">
              Manage Templates
              <ate-icon class="tw-text-brand-maroon" name="external-link"></ate-icon>
            </a>
          </div>
        </div>
        <div class="input-wrapper">
          <ate-singleselect
            id="templateUuid"
            model-key="templateUuid"
            formControlName="templateUuid"
            [options]="templateOptions"
            placeholder="Select a template"
            class="tw-rounded-lg tw-border-0 tw-shadow-[inset_0_0_0_1px_#94A3B8]">
          </ate-singleselect>
        </div>
      </div>

      <div class="tw-mx-5 tw-mt-5 tw-flex tw-flex-col tw-justify-between tw-rounded-lg tw-bg-slate-100 tw-p-5">
        <div class="form-row title !tw-border-0 !tw-px-0 !tw-py-2">
          <div class="header tw-mb-[10px] tw-flex tw-items-center tw-justify-between">
            <label for="from" class="!tw-mb-0">From</label>
            <a
              [routerLink]="['/su', listing?.uuid || 'me', 'integrations', 'email']"
              target="_blank"
              class="tw-flex tw-items-center tw-gap-1 tw-bg-gradient-to-r tw-from-brand-gradientfrom tw-to-brand-gradientto tw-bg-clip-text tw-font-bold tw-text-transparent">
              Email Settings
              <ate-icon class="tw-text-brand-maroon" name="external-link"></ate-icon>
            </a>
          </div>
          <div class="input-wrapper">
            <ate-text-input-control
              class="tw-rounded-lg"
              size="small"
              model-key="from"
              formControlName="from"
              [state]="'disabled'"></ate-text-input-control>
          </div>
        </div>

        <div class="form-row title !tw-border-0 !tw-px-0 !tw-py-2">
          <div class="header">
            <label for="to">To <span class="tw-text-red-600" title="Required">*</span></label>
          </div>
          <div class="input-wrapper">
            <ate-email-input-control
              placeholder="alice@acme.com"
              class="tw-rounded-lg"
              size="small"
              model-key="to"
              formControlName="to"
              [state]="form.get('to')?.invalid && (form.get('to')?.dirty || form.get('to')?.touched) ? 'error' : null">
            </ate-email-input-control>

            <div class="tw-pt-2 tw-text-red-700" *ngIf="form.get('to')?.hasError('multiEmail')">Please enter a valid email address.</div>
          </div>
        </div>

        <div class="form-row title !tw-border-0 !tw-px-0 !tw-py-2">
          <div class="header">
            <label for="subject">Subject <span class="tw-text-red-600" title="Required">*</span></label>
          </div>
          <div class="input-wrapper">
            <ate-text-input-control class="tw-rounded-lg" size="small" model-key="subject" formControlName="subject"></ate-text-input-control>
            @if (form.controls.subject?.errors?.unresolvedTemplateTags; as err) {
              <div class="tw-pt-2 tw-text-red-700">
                <p class="tw-mb-2">
                  {{ err.message }}
                </p>
                <ul class="tw-my-0">
                  @for (tag of err.tags; track tag) {
                    <li>[{{ tag }}]</li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>

        <div class="form-row message !tw-border-0 !tw-px-0 !tw-py-2">
          <div class="header">
            <div class="tw-flex tw-items-start tw-justify-between">
              <label for="message" class="required">Message <span class="tw-text-red-600" title="Required">*</span></label>
            </div>
          </div>
          <div
            (click)="onTextAreaClick()"
            (outsideClick)="onOutsideTextAreaClick()"
            [ngClass]="textAreaFocussed && 'tw-shadow-[0_0_0_2px_var(--brand-colour)]'"
            class="tw-overflow-hidden tw-rounded-lg tw-shadow-[0_0_0_1px_#6e7787]"
            *ngIf="isReply; else composeOnly">
            <ate-textarea-control
              #messageEl
              class="tw-shadow-none [&.focused:not(.error)]:tw-shadow-none [&_.ql-container]:tw-min-h-0"
              unlimited-height
              auto-resize
              use-rich-text
              model-key="message"
              formControlName="message">
            </ate-textarea-control>
            <div class="tw-bg-white tw-p-5 tw-pt-0">
              <div class="tw-mb-2 tw-text-sm">
                On {{ formattedOriginalDate }}, {{ message?.from?.name }} &lt;{{ message?.from?.email }}&gt; wrote:
              </div>
              <blockquote style="margin: 0 0 0 0.8ex; border-left: 1px solid #ccc; padding-left: 1ex">
                <email-html-viewer [html]="originalBody"></email-html-viewer>
              </blockquote>
            </div>
          </div>
          @if (form.controls.message?.errors?.unresolvedTemplateTags; as err) {
            <div class="tw-pt-2 tw-text-red-700">
              <p class="tw-mb-2">
                {{ err.message }}
              </p>
              <ul class="tw-my-0">
                @for (tag of err.tags; track tag) {
                  <li>[{{ tag }}]</li>
                }
              </ul>
            </div>
          }

          <ng-template #composeOnly>
            <ate-textarea-control #messageEl unlimited-height auto-resize use-rich-text model-key="message" formControlName="message">
            </ate-textarea-control>
          </ng-template>
        </div>

        <div class="form-row !tw-border-0 !tw-px-0 !tw-py-2">
          <section class="tw-flex tw-flex-col tw-gap-4" *ngIf="userUuid">
            <div>
              <asset-upload-field-component
                id="files"
                formControlName="files"
                [userUuid]="userUuid"
                [dropText]="'Drag & drop files here or click to choose'"
                (uploadError)="onFileUploadError($event)"
                assetType="all"
                [maxFiles]="5"
                [showLabel]="false">
              </asset-upload-field-component>
            </div>
          </section>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-5 tw-px-5 tw-py-5 tw-text-gray-600 md:tw-flex-row md:tw-items-center md:tw-justify-between md:tw-px-10">
        <ate-button-control
          color="secondary"
          (click)="onTemplateSaveClick()"
          [state]="isSavingTemplate || !canSaveTemplate() ? 'disabled' : 'normal'"
          class="tw-h-[40px] tw-w-full md:tw-w-fit">
          <ate-icon *ngIf="isSavingTemplate" class="tw-mr-2 tw-size-4 tw-animate-spin" name="loading-spinner-v3"></ate-icon>
          <ate-icon *ngIf="!isSavingTemplate" class="tw-mr-2 tw-size-4" name="save"></ate-icon>
          Save as Template
        </ate-button-control>
        <ate-button-control
          color="cta"
          type="submit"
          class="tw-h-[40px] tw-w-full md:tw-max-w-[150px]"
          (buttonClick)="onSubmit()"
          [state]="isSendingEmail || !form.valid ? 'disabled' : 'normal'">
          <ate-icon *ngIf="isSendingEmail" class="tw-mr-2 tw-size-4 tw-animate-spin tw-text-brand-contrast" name="loading-spinner-v3"></ate-icon>
          Send
        </ate-button-control>
      </div>
    </form>
  }
</div>

<ate-modal #failedUploadModal is-native="false" cta-text="Close" has-cancel="false">
  <h3 slot="header">Some files have failed to upload</h3>
  <div slot="body">
    <ul *ngFor="let error of fileUploadErrors">
      <li class="tw-text-left">
        <strong>{{ error }}</strong>
      </li>
    </ul>
  </div>
</ate-modal>
